import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  creatingYoutubeBlock,
  resetUser,
} from "../../../../../redux/slices/block/createYoutubeBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";
import { useForm } from "react-hook-form";
import MediaForm from "../forms/MediaForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

const Youtube = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const { media } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );

  // Youtube
  const youtubeCheck = blockFeature?.some(
    (item) => item.name === "youtube" && paymenetBlocks === 1
  );
  // Instagram
  const instagramCheck = blockFeature?.some(
    (item) => item.name === "instagram" && paymenetBlocks === 1
  );
  // Twitter
  const twitterCheck = blockFeature?.some(
    (item) => item.name === "twitter" && paymenetBlocks === 1
  );
  // Tiktok
  const tiktokCheck = blockFeature?.some(
    (item) => item.name === "tiktok" && paymenetBlocks === 1
  );
  useEffect(() => {
    switch (media) {
      case "youtube":
        if (!youtubeCheck) {
          navigate("/pricing");
        }
        break;
      case "twitter":
        if (!twitterCheck) {
          navigate("/pricing");
        }
        break;
      case "instagram":
        if (!instagramCheck) {
          navigate("/pricing");
        }
        break;
      case "tiktok":
        if (!tiktokCheck) {
          navigate("/pricing");
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [subLoader, setSubLoader] = useState(false);

  // https://www.tiktok.com/[^/?]+
  const { reset } = useForm({});

  const onSubmit = async (data) => {
    setSubLoader(true);
    const userData = {
      coloumnValue: data.coloum_value,
      columnName: media,
      coloumnType: media,
      language : data?.language,
    };
    await dispatch(creatingYoutubeBlock(userData));
    setSubLoader(false);
    fetchingLinksList();
  };

  const fetchingLinksList = () => {
    //  _______data needed for linklist api
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const userToken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      userToken,
      linkId,
    };

    dispatch(gettingLinkList(linkListData));
  };

  const { isYoutubeBlockError, isYoutubeBlockSuccess, isYoutubeBlockLoading } =
    useSelector((state) => state?.youtubeBlock);
  const { status, message } = useSelector(
    (state) => state?.youtubeBlock?.youtubeBlock
  );
  useEffect(() => {
    if (status === "success" && isYoutubeBlockSuccess) {
      toast.success(message);
      reset();
      navigate("/dashboard");
    }
    if (status === "failed" && isYoutubeBlockSuccess) {
      toast.error(message);
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isYoutubeBlockError,
    isYoutubeBlockSuccess,
    dispatch,
    isYoutubeBlockLoading,
  ]);

  return (
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark"> {translate("media")} </p>
          </div>
        </Link>
      </div>
      <MediaForm
        formType={"add"}
        onSubmitMdiaLink={onSubmit}
        isLoading={subLoader}
      />
    </>
  );
};

export default Youtube;
